<template lang="pug">
  include /mixins
  div
    product-sale-view(
      v-bind='productProps'
      v-on='productListeners'
      v-if='showGifts'
      :is-simple="isSimple"
      :is-order="isOrder"
    )
    //- product-base-view(
    //-   v-bind='productProps'
    //-   v-on='productListeners'
    //- )

</template>
<script>
import ProductBaseView from './Variants/Base'
import ProductSaleView from './Variants/Sale'

export default {
  name: 'CartCampaignUi',
  components: {
    ProductBaseView,
    ProductSaleView,
  },
  props: {
    product: {
      default: () => { },
    },
    load: {},
    showGifts: {
      type: Boolean,
      default: false,
    },
    isSimple: {
      type: Boolean,
      default: false,
    },
    isOrder: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    productListeners() {
      return {
        ...this.$listeners,
        removeFromCart: () => this.$emit('removeFromCart'),
        updateCart: event => this.$emit('updateCart', event),
      }
    },
    productProps() {
      const { relations, base, price, id } = this.product
      return {
        load: this.load,
        product: base,
        group_id: id,
        relations,
        price,
        disabled: this.$attrs.disabled,
      }
    },
  },
}
</script>
